import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  //定义状态
  state: {
    id: '',//用户id
    headimg: '',//用户头像
    realname: '',//用户名 
	RouteFrom:{},
  },
	
  // 获取仓库的值
  getters: {},
  // 改变状态
  mutations: {
    id (state, id) {
      state.id = id;
    },
    headimg (state, headimg) {
      state.headimg = headimg;
     
    },
    realname(state, realname) {
      state.realname = realname;
      
    }
  }
})
export default store


// WEBPACK FOOTER //
// ./src/vuex/store.js